import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import Papa from "papaparse";

/**
 * Map rows to flat objects using column defs, if you need custom headers/order
 */
export function mapRows(rows, columns) {
  if (!columns || !columns.length) return rows;
  return rows.map((row) => {
    const out = {};
    for (const col of columns) {
      const raw = row[col.key];
      out[col.header || String(col.key)] = col.transform
        ? col.transform(raw, row)
        : raw;
    }
    return out;
  });
}

/**
 * CSV export using PapaParse (adds UTF-8 BOM for Excel compatibility)
 */
export function exportToCSV(rows, fileName = "data", columns) {
  const data = mapRows(rows, columns);
  const csv = Papa.unparse(data, { quotes: true });
  // Add BOM so Excel respects UTF-8
  const blob = new Blob(["\ufeff", csv], { type: "text/csv;charset=utf-8;" });
  saveAs(blob, `${fileName}.csv`);
}

/**
 * Excel export using SheetJS
 */
export function exportToXLSX(rows, fileName = "data", columns, sheetName = "Sheet1") {
  const data = mapRows(rows, columns);
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);

  // Auto-width columns
  const headers = Object.keys(data[0] || {});
  ws["!cols"] = headers.map((h) => ({ wch: Math.max(10, h.length + 2) }));

  XLSX.writeFile(wb, `${fileName}.xlsx`);
}
